import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "form-group"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "form-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-change-username", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Change username")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Current username")) + ":", 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "old-username",
            readonly: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
            disabled: _ctx.busy,
            maxlength: "255",
            class: "form-control form-control-full-width"
          }, null, 8, _hoisted_9), [
            [_vModelText, _ctx.username]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("New username")) + ":", 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "username",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUsername) = $event)),
            disabled: _ctx.busy,
            maxlength: "255",
            class: "form-control form-control-full-width auto-focus"
          }, null, 8, _hoisted_11), [
            [_vModelText, _ctx.newUsername]
          ])
        ]),
        (_ctx.tfa)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("Input your one-time password")) + ":", 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "tfa-token",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.token) = $event)),
                disabled: _ctx.busy,
                maxlength: "255",
                class: "form-control form-control-full-width"
              }, null, 8, _hoisted_13), [
                [_vModelText, _ctx.token]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.busy || !_ctx.newUsername || _ctx.username === _ctx.newUsername,
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.$t("Change username")), 9, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.error), 1)
      ])
    ], 32)
  ], 42, _hoisted_1))
}